import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute z-20 w-screen h-screen border-4 border-opacity-0 flex justify-between" }

import { reactive, watch } from 'vue'
import cloneDeep from 'lodash.clonedeep'
import Background from './components/Background.vue'
import ScoreboardColumn from './components/ScoreboardColumn.vue'
import PlayerColumn from './components/PlayerColumn.vue'
import TopBar from './components/TopBar.vue'
import BottomBar from './components/BottomBar.vue'
import Arrow from './components/Arrow.vue'
import { IAppState, ILog } from './interfaces'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state = reactive<IAppState>({
	direction: '',
	serverPair: 0,
	server: 0,
	receiver: 0,
	leftPair: {
		id: 42,
		playerA: { name: 'A', id: 1 },
		playerB: { name: 'B', id: 2 },
		point: 0
	},
	rightPair: {
		id: 66,
		playerA: { name: 'C', id: 3 },
		playerB: { name: 'D', id: 4 },
		point: 0
	},
	lockNames: false,
	lockPointBtns: true,
	logs: []
})

const switchPair = () => {
	addLog()
	;[state.leftPair, state.rightPair] = [state.rightPair, state.leftPair]
	setArrow()
}

const setServer = (playerId: number, pairId: number) => {
	addLog()
	if (state.serverPair && pairId !== state.serverPair) {
		if (state.receiver === playerId) {
			state.receiver = 0
			state.direction = ''
		} else {
			state.receiver = playerId
			setArrow()
		}
	} else {
		if (state.server == playerId) {
			state.server = 0
			state.serverPair = 0
			state.direction = ''
		} else {
			state.server = playerId
			if (state.receiver) setArrow()
			state.serverPair = pairId
		}
	}
}

const addPoint = (id: number) => {
	addLog()
	const { leftPair, rightPair, direction } = state
	state.lockNames = true
	if (leftPair.id === id) {
		++leftPair.point
	} else {
		++rightPair.point
	}
	const sum = leftPair.point + rightPair.point
	if (Math.max(leftPair.point, rightPair.point) > 10 && Math.abs(leftPair.point - rightPair.point) >= 2) {
		alert(`Setet slutade ${leftPair.point}-${rightPair.point}`)
		reset()
		return
	}
	if (sum > 20 || sum % 2 === 0) {
		if (direction) {
			const { playerA, playerB } = leftPair.id === state.serverPair ? leftPair : rightPair
			const newreceiver = playerA.id === state.server ? playerB.id : playerA.id
			state.server = state.receiver
			state.receiver = newreceiver
			state.serverPair = leftPair.id !== state.serverPair ? leftPair.id : rightPair.id
			setArrow()
		}
	}
}

const setArrow = () => {
	const { leftPair, rightPair, server, receiver, serverPair } = state
	if (!server || !receiver) {
		return
	}
	let firstLetter, lastLetter
	if (leftPair.id === serverPair) {
		firstLetter = leftPair.playerA.id === server ? 'A' : 'C'
		lastLetter = rightPair.playerA.id === receiver ? 'B' : 'D'
	} else {
		firstLetter = rightPair.playerA.id === server ? 'B' : 'D'
		lastLetter = leftPair.playerA.id === receiver ? 'A' : 'C'
	}

	state.direction = firstLetter + lastLetter
	state.lockNames = true
	console.log(state.direction)
}

const toggleLock = () => (state.lockNames = !state.lockNames)

const addLog = () => {
	const { server, serverPair, receiver, direction, leftPair, rightPair } = state
	const data: ILog = {
		direction,
		serverPair,
		server,
		receiver,
		leftPair,
		rightPair
	}
	state.logs.push(cloneDeep(data))
}

const undo = () => {
	const log = state.logs.pop() as ILog
	if (log) {
		state.direction = log.direction
		state.serverPair = log.serverPair
		state.server = log.server
		state.receiver = log.receiver
		state.leftPair = log.leftPair
		state.rightPair = log.rightPair
	}
}

const reset = () => {
	state.leftPair.point = 0
	state.rightPair.point = 0
	state.lockPointBtns = true
	state.server = 0
	state.receiver = 0
	state.serverPair = 0
	state.direction = ''
}

watch(
	() => [state.server, state.receiver],
	([server, receiver]) => (state.lockPointBtns = !(server && receiver))
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Background),
    _createVNode(Arrow, {
      direction: _unref(state).direction
    }, null, 8, ["direction"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(PlayerColumn, {
        pair: _unref(state).leftPair,
        server: _unref(state).server,
        receiver: _unref(state).receiver,
        isLocked: _unref(state).lockNames,
        pointBtnLocked: _unref(state).lockPointBtns,
        onSetServer: setServer,
        onAddPoint: addPoint
      }, null, 8, ["pair", "server", "receiver", "isLocked", "pointBtnLocked"]),
      _createVNode(ScoreboardColumn, {
        pairA: _unref(state).leftPair,
        pairB: _unref(state).rightPair
      }, null, 8, ["pairA", "pairB"]),
      _createVNode(PlayerColumn, {
        pair: _unref(state).rightPair,
        server: _unref(state).server,
        receiver: _unref(state).receiver,
        isLocked: _unref(state).lockNames,
        pointBtnLocked: _unref(state).lockPointBtns,
        onSetServer: setServer,
        onAddPoint: addPoint
      }, null, 8, ["pair", "server", "receiver", "isLocked", "pointBtnLocked"])
    ]),
    _createVNode(TopBar, {
      isLocked: _unref(state).lockNames,
      onToggleLock: toggleLock
    }, null, 8, ["isLocked"]),
    _createVNode(BottomBar, {
      isLocked: !_unref(state).logs.length,
      onUndo: undo,
      onSwitchPair: switchPair
    }, null, 8, ["isLocked"])
  ], 64))
}
}

})